import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfitLossStatementComponent } from '@teem/profit-loss-statement/profit-loss-statement.component';

import { ProfitLossStatementRoutingModule } from '@teem/profit-loss-statement/profit-loss-statement-routing.module'


@NgModule({
  declarations: [
    ProfitLossStatementComponent
  ],
  imports: [
    CommonModule,
    ProfitLossStatementRoutingModule
  ]
})
export class ProfitLossStatementsModule {}
